<template>
  <div id="publicClass_list">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <!-- banner end -->
    <div class="screen w1200">
      <div class="clearfix screen_1">
        <em></em>
        公开课程
      </div>
      <div class="clearfix screen_2" :class="{ up: screenup }">
        <p>
          <strong>课程分类：</strong>
          <span>
            <a :class="{ side: num1 == -1 }" @click="screenNone1()">不限</a>
            <a :class="{ side: index == num1 }" v-for="(item, index) in ulList"
              @click="screenC(index)">{{ item.Name }}</a>
          </span>
        </p>
        <p v-if="CourseC1">
          <strong>科目分类：</strong>
          <span>
            <a :class="{ side: num2 == -1 }" @click="screenNone2()">不限</a>
            <a :class="{ side: index == num2 }" v-for="(item, index) in ulList2" @click="screenD(index)">{{ item }}</a>
          </span>
        </p>
        <p>
          <strong>时间分类：</strong>
          <span>
            <a :class="{ side: gkgLb == 2 }" @click="gkkList(2)">不限</a><em></em>
            <a :class="{ side: gkgLb == 0 }" @click="gkkList(0)">公开课列表</a><em></em>
            <a :class="{ side: gkgLb == 1 }" @click="gkkList(1)">往期公开课</a>
          </span>
        </p>
      </div>
    </div>
    <!-- screen end -->

    <div class="main">
      <div class="main_list">
        <ul class="clearfix" v-if="maniList">
          <li v-for="(item, index) in kcList">
            <dl class="clearfix">
              <dt>
                <strong>{{ item.BeginTime.substr(0, 4) + "." + item.BeginTime.replace(/-/g, "").substr(4, 2) + "." + item.BeginTime.replace(/-/g, "").substr(6, 2)}}</strong>
                <span>{{item.BeginTime.replace(/-/g, "").substr(9, 5) + "-" + item.EndTime.substr(11, 5)}}</span>
              </dt>
              <dd>
                <em><i :class="{on:item.VideoId&&item.VideoToken}"></i></em>
                <div class="box">
                  <h2>{{ item.Title }}</h2>
                  <p class="p1">
                    {{ item.SubTitle }}
                  </p>
                  <div class="p3 clearfix">
                    <div class="p3Li clearfix" v-for="(item2,index2) in item.Staff" :key="item2.Id">
                      <div class="HeadUrl"><img :src="item2.HeadUrl" /></div>
                      <div class="con">
                        <p>
                          <strong>{{item2.Name}}</strong>
                        </p>
                        <p class="of2" v-if="item2.Academic">
                          <span>学术背景：</span>{{item2.Academic}}
                        </p>
                        <p class="of2" v-if="item2.CourseScore">
                          <span>学科分数：</span>{{item2.CourseScore}}
                        </p>
                      </div>
                    </div>
                  </div>
                  <p class="p4" v-if="item.SynopsisText">
                    {{ "课程简介：" + item.SynopsisText ? item.SynopsisText : "" }}
                  </p>
                  <div class="btn" @click="watchlog2(3, item.RoomId, item.VideoToken, item.VideoId, item.Title);"
                    v-if="item.VideoToken&&item.VideoId">
                    查看回放
                  </div>
                  <div class="btn ob" v-else>
                    查看回放
                  </div>
                </div>
              </dd>
            </dl>
          </li>
        </ul>
      </div>
      <!-- main_list end -->
      <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="12"
          :total="total" background layout="total,prev, pager, next, jumper,->">
        </el-pagination>
      </div>
      <!-- block end -->
    </div>
    <!-- main end -->
  </div>
</template>

<script>
  import Header from "../../components/header/Header.vue"; //公共头部

  import banner from "../../page2/banner/banner.vue"; //头部banner图
  export default {
    name: "App",
    props: ["enum"],
    components: {
      // 将组件隐射为标签,登陆弹窗
      Header,

      banner
    },
    metaInfo() {
      return {
        title: "热门公开课",
        meta: [{
            name: "keywords",
            content: "启德考培公开课,雅思公开课,托福公开课"
          },
          {
            name: "description",
            content: "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
          }
        ]
      };
    },
    data() {
      return {
        screenup: false,
        pageTypeId: 19,
        maniList: "",
        currentPage: 1, // 当前页码
        total: 12, // 总条数
        pageSize: 12, // 每页的数据条数

        ulList: "", //枚举列表
        ulList2: [],
        CourseC1: false,
        num1: "",
        num2: "",
        kcList: [], //课程列表
        ysListId: "", //课程Id
        kmIds: [], //科目Id
        sorts: "1", //排序方式
        gkgLb: "2",

        courseId: 0, //课程分类
        subjectId: 0, //科目分类
        num6: 2, //排序方式
        type: 2, //公开课程
        searchValue: "" //搜索至
      };
    },
    // updated() {
    //     window.scroll(0, 0);
    // },
    created() {
      let that = this;
      // this.$router.push({ query: {nav:3} });
      //默认筛选分类
      let a = sessionStorage.getItem("enum");
      //// console.log(JSON.parse(a))
      this.ulList = JSON.parse(a)[0].List;
      //// console.log(this.ulList)
      //枚举筛选列表数据
      let objName = this.ulList[0].List;
      // // console.log(this.ulList)
      let numbers = [];
      objName.filter(item => {
        if (item.Type === 2) {
          numbers.push(item.Name);
        }
      });
      this.ulList2 = numbers;
      this.num1 = -1;
      this.num2 = -1;
      this.ulList2 = "";

      var typelist = this.$route.query;
      // console.log(typelist)
      if (typelist == 2) {
        this.typelist = false;
        this.maniList = false;
      } else {
        this.typelist = true;
        this.maniList = true;
      }
    },
    mounted: function() {
      //自动触发写入的函数
      this.getDataListFu(
        this.currentPage,
        this.courseId,
        this.subjectId,
        this.num6,
        this.type,
        this.searchValue
      );
    },
    methods: {
      //当前页改变时触发 跳转其他页
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;
        this.getDataListFu(
          this.currentPage,
          this.courseId,
          this.subjectId,
          this.num6,
          this.type,
          this.searchValue
        );
      },

      getDataListFu(currentPage, courseId, subjectId, num6, type, keyword) {
        let that = this;
        // console.log(currentPage, courseId, subjectId, num6, type, keyword)
        this.$api.get(
          "https://schoolapi.eiceducation.com.cn/api/OpenCourse?page=" +
          currentPage +
          "&limit=12&courseType=" +
          courseId +
          "&subjectType=" +
          subjectId +
          "&orderType=" +
          num6 +
          "&type=" +
          type +
          "&keyword=" +
          keyword,
          "",
          res => {
            if (res.data.code == 200) {
              // console.log(res)
              that.kcList = res.data.results;
              that.total = res.data.count;
            }
          }
        );
      },
      //点击课程分类----不限
      screenNone1(a1) {
        let that = this;
        this.num1 = -1;
        this.num2 = -1;
        this.CourseC1 = false;
        this.currentPage = 1; //点击时默认分页为第一页
        this.courseId = 0;
        this.getDataListFu(
          this.currentPage,
          this.courseId,
          this.subjectId,
          this.num6,
          this.type,
          this.searchValue
        );
      },
      //点击科目分类-----不限
      screenNone2(a1) {
        let that = this;
        this.num2 = -1;
        // this.kcList = [] //点击课程分类时先清空列表
        this.currentPage = 1; //点击时默认分页为第一页
        this.subjectId = 0;
        this.getDataListFu(
          this.currentPage,
          this.courseId,
          this.subjectId,
          this.num6,
          this.type,
          this.searchValue
        );
      },
      //点击课程分类-------------------------------
      screenC(a) {
        let that = this;
        this.num1 = a;
        this.num2 = -1; //点击不限时赋值
        this.CourseC1 = true;
        this.currentPage = 1; //点击时默认分页为第一页
        // this.kcList = [] //点击课程分类时先清空列表
        let objName = this.ulList[a].List;
        let numbers = [];
        let kmId = [];
        objName.filter(item => {
          if (item.Type === 2) {
            numbers.push(item.Name);
            kmId.push(item.Id);
          }
        });
        this.ulList2 = numbers;
        this.kmIds = kmId; //科目ID
        //筛选请求

        //// console.log(this.ulList[a])
        this.courseId = this.ulList[a].Id;
        //点击雅思，托福，发送的请求
        this.getDataListFu(
          this.currentPage,
          this.courseId,
          this.subjectId,
          this.num6,
          this.type,
          this.searchValue
        );
      },
      //点击科目分类FU-----------
      screenD(b) {
        let that = this;
        this.num2 = b;
        this.currentPage = 1; //点击时默认分页为第一页
        this.subjectId = this.kmIds[this.num2];
        this.getDataListFu(
          this.currentPage,
          this.courseId,
          this.subjectId,
          this.num6,
          this.type,
          this.searchValue
        );
      },
      //点击排序方式----开课时间
      sort1(e) {
        let that = this;
        this.sorts = e;
        this.currentPage = 1; //点击时默认分页为第一页
        this.num6 = e;
        // this.kcList = [] //点击课程分类时先清空列表
        this.getDataListFu(
          this.currentPage,
          this.courseId,
          this.subjectId,
          this.num6,
          this.type,
          this.searchValue
        );
      },
      gkkList(e) {
        let that = this;
        this.gkgLb = e;
        // this.kcList = [] //点击课程分类时先清空列表
        this.currentPage = 1; //点击时默认分页为第一页
        this.type = this.gkgLb;
        this.getDataListFu(
          this.currentPage,
          this.courseId,
          this.subjectId,
          this.num6,
          this.type,
          this.searchValue
        );
      },

      //tyoeid播放类型 1直播/2点播/3回放
      //roomid 房间号
      //按钮类型contentType 183公开课
      //contentId 公开课id
      watchlog2(tyoeid, scheduleId, videoid, videotoken, TxVideoId, title) {
        let that = this;
        // 1直播/2点播/3回放
        if (TxVideoId) {
          window.open(
            "https://online.eickaopei.com/video.html?title=" + title + "&id=" + TxVideoId, "_blank");
          return;
        }
        if (tyoeid == 2) {
          window.open(
            "https://b96135432.at.baijiayun.com/web/video/player?vid=" +
            videoid +
            "&token=" +
            videotoken +
            "&player=h5&user_number=" +
            that.$parent.UserInfos.Number +
            "&user_name=" +
            that.$parent.UserInfos.NickName,
            "_blank"
          );
        } else {
          window.open(
            "https://b96135432.at.baijiayun.com/web/playback/index?classid=" +
            videoid +
            "&token=" +
            videotoken +
            "&player=h5&user_number=" +
            that.$parent.UserInfos.Number +
            "&user_name=" +
            that.$parent.UserInfos.NickName,
            "_blank"
          );
        }
        // this.WatchLogJL(tyoeid, scheduleId, videoid)
      },
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bottombox {
    box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
    position: relative;
    z-index: 9;
  }

  .header_left {
    background: #f00;
  }

  .banner {
    width: 100%;
    height: 452px;
    position: relative;
    overflow: hidden;
  }

  .banner img {
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -960px;
  }

  .screen {
    background: #fff;
  }

  .screen_1 {
    width: 1175px;
    font-weight: 500;
    font-size: 38px;
    color: #333333;
    line-height: 38px;
    position: relative;
    padding-left: 25px;
    margin: 30px 0;
  }

  .screen_1 em {
    width: 5px;
    height: 38px;
    background: #FF0659;
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .screen_2 {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .screen_2.up {
    display: none;
  }

  .screen_2 p {
    margin-bottom: 30px;
    text-align: left;
    display: table;
  }

  .screen_2 p strong {
    display: inline-block;
    margin-right: 24px;
    float: left;
    font-weight: 400;
    font-size: 20px;
    color: #666666;
    line-height: 28px;
  }

  .screen_2 p span {
    display: inline-block;
    width: 1070px;
    float: left;
  }

  .screen_2 p a {
    display: inline-block;
    min-width: 82px;
    height: 28px;
    font-size: 20px;
    line-height: 28px;
    border-radius: 14px 14px 14px 14px;
    margin-right: 10px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    cursor: pointer;
    padding: 0 20px;
    box-sizing: border-box;
    transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -webkit-transition: all 0.25s ease-in;
  }

  .screen_2 p a:hover {
    color: rgba(51, 124, 255, 1);
  }

  .screen_2 p a.side {
    background: rgba(51, 124, 255, 0.05);
    color: rgba(51, 124, 255, 1);
  }

  .main {
    width: 100%;
    background: #FFFFFF;
    padding-top: 30px;
    padding-bottom: 78px;
  }

  .main_list {
    width: 1200px;
    margin: 0 auto;
  }

  .main_list ul {
    padding-bottom: 60px;
  }

  .main_list ul li {
    width: 100%;
    position: relative;
  }

  .main_list ul li dl dt {
    width: 110px;
    padding-top: 15px;
    float: left;
  }

  .main_list ul li dl dt strong {
    display: block;
    text-align: center;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    line-height: 20px;
    margin-bottom: 10px;
  }

  .main_list ul li dl dt span {
    display: block;
    width: 85px;
    height: 22px;
    background: rgba(135, 141, 255, 0.05);
    border-radius: 13px 13px 13px 13px;
    text-align: center;
    font-weight: 400;
    font-size: 12px;
    color: #878DFF;
    line-height: 22px;
    margin: 0 auto;
  }

  .main_list ul li dl dd {
    width: 1030px;
    float: left;
    padding-left: 60px;
    position: relative;
    padding-bottom: 100px;
  }
  .main_list ul li dl dd:last-child{
    padding-bottom: 0;
  }

  .main_list ul li dl dd em {
    position: absolute;
    width: 1px;
    height: 100%;
    top: 0;
    left: 20px;
    background: rgba(236, 236, 236, 1);
  }

  .main_list ul li dl dd em i {
    width: 24px;
    height: 24px;
    position: absolute;
    left: -12px;
    top: 12px;
    background: url(../../assets/publicClass/icon1.png) no-repeat;
    background-size: cover;
  }

  .main_list ul li dl dd em i.on {
    width: 24px;
    height: 24px;
    position: absolute;
    left: -12px;
    top: 12px;
    background: url(../../assets/publicClass/icon2.png) no-repeat;
    background-size: cover;
  }

  .main_list .box {
    width: 1030px;
    background: #FBFBFB;
    padding: 60px 30px 30px;
    position: relative;
  }

  .main_list .box h2 {
    height: 50px;
    background: url(../../assets/publicClass/icon3.png) right #878DFF no-repeat;
    font-weight: 500;
    font-size: 26px;
    color: #FFFFFF;
    line-height: 50px;
    text-align: left;
    padding-left: 30px;
    padding-right: 80px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .main_list .box .p1 {
    font-weight: 400;
    font-size: 16px;
    color: #878DFF;
    line-height: 24px;
  }

  .main_list .box .p3 {
    padding-top: 16px;
    padding-bottom: 20px;
  }

  .main_list .box .p3Li {
    margin-right: 10px;
    float: left;
  }

  .main_list .box .p3Li .HeadUrl {
    width: 92px;
    height: 82px;
    background: #D8D8D8;
    overflow: hidden;
    border-radius: 46px;
    padding-top: 10px;
    float: left;
    margin-right: 15px;
  }

  .main_list .box .p3Li .HeadUrl img {
    display: block;
    width: 100%;
    margin: 0 auto;
  }

  .main_list .box .p3Li .con {
    display: flex;
    align-items: center;
    display: block;
    width: 200px;
    float: left;
  }

  .main_list .box .p3Li .con strong {
    display: block;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 10px;
  }

  .main_list .box .p3Li .con p {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #333333;
    white-space: pre-wrap;
  }

  .main_list .box .p3Li .con p span {
    color: #666666;
  }

  .main_list .box .p4 {
    width: 972px;
    background: #FFFFFF;
    padding: 10px 20px;
    font-weight: 350;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }

  .main_list .box .p4 span {
    color: #333333;
  }

  .main_list .box .btn {
    width: 98px;
    height: 28px;
    background: #337CFF;
    border-radius: 15px 15px 15px 15px;
    border: 1px solid #337CFF;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 16px;
    text-align: center;
    line-height: 28px;
    position: absolute;
    top: 20px;
    right: 28px;
    cursor: pointer;
  }

  .main_list .box .ob {
    border: 1px solid #D8D8D8;
    background: #FBFBFB;
    color: #666666;
    cursor: default;
  }

  .block {
    width: 1200px;
    margin: 0 auto;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/page2/publicClass/publicClass_list.vue